<template>
  <!-- 税务违法 -->
  <div>
    <block>
      <div id="administrativePenaltyCount" style="position: relative;height: 0;overflow: hidden;top: -120px;"></div>
      <div class="table-list-title dis-bet-cen">
        <div>重大税收违法 <span style="color: #5D6FE9;">{{page.total}}</span></div>
      </div>
      <el-table
        border
        :data="TableData"
        :cell-style="cellStyle"
        :header-cell-style="headerColor"
        style="width: 100%;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.label" :property="item.property" align="center">
          <template #default="scope">
            <span>{{scope.row[scope.column.property] || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!fuzzyDataShow && !returnLimit"
          label="操作"
          width="80">
          <template #default="scope">
           <el-button type="text" @click="handleTo(scope.row)">详情</el-button>
          </template>
        </el-table-column>
        <template #empty style="width: 100%;">
          <gaussian-blur-empty-login @loginEmit="loginEmit" v-show="!islogin"></gaussian-blur-empty-login>
          <gaussian-blur-empty-vip @loginEmit="loginEmit" v-show="fuzzyDataShow && returnLimit"></gaussian-blur-empty-vip>
          <gaussian-blur-empty-vip @loginEmit="loginEmit" v-show="!fuzzyDataShow && returnLimit && TableData.length == 0"></gaussian-blur-empty-vip>
        </template>
      </el-table>
      <gaussian-blur-empty-vip @loginEmit="loginEmit" v-show="!fuzzyDataShow && returnLimit && TableData.length > 0"></gaussian-blur-empty-vip>
      <div class="table-page" v-show="!fuzzyDataShow && !returnLimit">
        <el-pagination
          background
          hide-on-single-page="true"
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          v-model:currentPage="page.pageNum"
          @current-change="pageChange"
          :total="page.total">
        </el-pagination>
        <el-dialog title="重大税收违法详情" :append-to-body="appendtobody" v-model="dialogTableVisible">
            <el-descriptions class="margin-top"  :column="1" :size="size" border>
              <el-descriptions-item :span="1">
                <template #label>纳税人名称</template>
                {{companyDetail.companyName || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>纳税人识别号</template>
                {{companyDetail.taxpayerNumber || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>组织机构代码</template>
                {{companyDetail.organizationCode || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>注册地址</template>
                {{companyDetail.address || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>案件性质</template>
                {{companyDetail.type || '-'}}
              </el-descriptions-item>
              <!-- <el-descriptions-item :span="1">
                <template #label>案件上报日期</template>
                {{companyDetail.executegov || '-'}}
              </el-descriptions-item> -->
              <el-descriptions-item :span="1">
                <template #label>主要违法事实</template>
                {{companyDetail.executeunite || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>相关法律依据及税收处理处罚情况</template>
                {{companyDetail.executestatus || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>法定代表人或负责人</template>
                {{companyDetail.corporation || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>负有责任的财务负责人</template>
                {{companyDetail.financialPerson || '-'}}
              </el-descriptions-item>
              <el-descriptions-item :span="1">
                <template #label>负有直接责任的中介机构信息及其他从业人员信息</template>
                {{companyDetail.agency || '-'}}
              </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
      </div>
    </block>
  </div>
</template>

<script>
import { oldForwardBG } from '@/api/forward.js'
import GaussianBlurEmptyLogin from '@/components/gaussian-blur/gaussian-blur-empty-login'
import GaussianBlurEmptyVip from '@/components/gaussian-blur/gaussian-blur-empty-vip'
import { mapGetters } from 'vuex'
export default {
  setup (props, context) {
    function loginEmit () {
      context.emit('loginEmit', 'company')
    }
    return {
      loginEmit
    }
  },
  components: { GaussianBlurEmptyLogin, GaussianBlurEmptyVip },
  name: 'administrative-penalty-count',
  props: { companyId: String, num: Number },
  data () {
    return {
      appendtobody: true,
      companyDetail: {},
      dialogTableVisible: false,
      page: {
        total: this.num ? this.num : 0,
        pageNum: 1
      },
      // 股东信息
      tableHeader: [{
        label: '发布日期',
        property: 'publicityDate'
      }, {
        label: '纳税人名称',
        property: 'companyName'
      }, {
        label: '纳税人识别号',
        property: 'taxpayerNumber'
      }, {
        label: '组织机构代码',
        property: 'organizationCode'
      }, {
        label: '案件性质',
        property: 'type'
      }],
      TableData: [],
      islogin: false,
      returnLimit: false,
      fuzzyDataShow: false
    }
  },
  computed: {
    ...mapGetters([
      'vipData', // 会员数据
      'idToken',
      'userInfo'
    ]),
    vipLevelChange: function () {
      const vm = this
      if (vm.vipData && JSON.parse(vm.vipData)) {
        return JSON.parse(vm.vipData).vipLevel
      } else {
        return null
      }
    }
  },
  mounted () {
    if (this.idToken) {
      this.islogin = true
      this.initData()
    } else {
      this.islogin = false
    }
  },
  watch: {
    idToken: {
      handler (val, oldval) {
        if (val) {
          if (this.idToken) {
            this.islogin = true
            this.initData()
          } else {
            this.islogin = false
          }
        }
      }
    },
    vipLevelChange: function (newValue, oldValue) {
      if (this.idToken) {
        this.islogin = true
        this.initData()
      } else {
        this.islogin = false
      }
    }
  },
  methods: {
    handleTo (e) {
      this.dialogTableVisible = true
      this.companyDetail = e
    },
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    pageChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    initData: function () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/CompanyAdministrativePenalty/getAdministrativePenaltyList',
        dateBackgroundRequestType: 'get',
        data: {
          companyId: vm.companyId,
          penaltyType: 2,
          pageNum: vm.page.pageNum,
          pageSize: 10
        }
      }
      oldForwardBG(data).then(result => {
        console.log('违法')
        console.log(result)
        if (result.code === 0 || result.code === 97 || result.code === 98) {
          if (result.code === 97) {
            vm.returnLimit = true
            vm.fuzzyDataShow = false
          } else if (result.code === 98) {
            vm.returnLimit = true
            vm.fuzzyDataShow = true
          } else {
            vm.returnLimit = false
            vm.fuzzyDataShow = false
          }
          const res = result.data.pageResult
          const arr = []
          vm.page.total = res.total
          res.list.forEach(item => {
            item.liandate = item.liandate ? item.liandate.substring(0, 10) : '-'
            item.publicdate = item.publicdate ? item.publicdate.substring(0, 10) : '-'
            arr.push(item)
          })
          vm.TableData = arr
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
.table-list-title {
  padding: 18px 0;
  text-align: left;
  color: #333;
  font-weight: bold;
}
.table-page {
  text-align: right;
  margin-top: 10px;
}
/deep/ .el-table__empty-text {
  width: 100%;
}
</style>
